var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.gridStyle)},[_vm._l((_vm.gridContent),function(item,index){return [_c('Content',{key:("" + (item.id) + index),class:{ 'spaced-evenly': _vm.contentIsSpacedEvenly },attrs:{"content":item.content}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }